// @ts-nocheck
import type { RouterConfig } from "@nuxt/schema";
import i18nConfig from "@/i18n.config";

import {
	NavigationMenu,
	SystemSettingsSection,
	QuartzManagement,
	PublicArticlesSection,
	PublicArticleEditCard,
	PublicArticleView,
	SystemEventsSection,
	ComponentPresetsViewer,
} from "@products/base-portal-lib";

const _customRoutes = [
	/**
	 * AUTHORIZATION
	 */
	{
		name: "Home",
		path: "/",
		component: () => import("~/pages/index.vue"),
	},
	{
		name: "Sign In",
		path: "/signin",
		component: () => import("~/pages/auth/signin.vue"),
		meta: {
			layout: "public",
		},
	},
	{
		name: "Sign In (Admin)",
		path: "/admin/signin",
		component: () => import("~/pages/admin/auth/signin.vue"),
		meta: {
			layout: "public",
		},
	},
	/**
	 * NAVIGATION MENU
	 */
	{
		name: "Navigation menu management",
		path: "/admin/NavigationMenu",
		component: NavigationMenu,
		props: () => ({ usePages: true }),
	},
	/**
	 * SYSTEM SETTINGS
	 */
	{
		name: "System Settings",
		path: "/admin/system-settings",
		component: SystemSettingsSection,
		meta: {
			sectionName: "Системні налаштування",
			isSection: true,
		},
	},
	/**
	 * SYSTEM EVENTS
	 */
	{
		name: "System Events",
		path: "/admin/system-events",
		component: SystemEventsSection,
		meta: {
			sectionName: "Системні події",
			isSection: true,
		},
	},
	/**
	 * INTEGRATION SYSTEMS
	 */
	{
		name: "Integration Systems",
		path: "/admin/integration-systems",
		component: () =>
			import(
				"~/components/admin/integration-systems/IntegrationSystemsSection.vue"
			),
		meta: {
			sectionName: "Інтеграційні системи",
			isSection: true,
		},
	},
	{
		name: "Integration Systems Logs",
		path: "/admin/integration-systems/logs",
		component: () =>
			import(
				"~/components/admin/integration-systems/IntegrationSystemLogsSection.vue"
			),
		meta: {
			sectionName: "Логи інтеграційних систем",
			isSection: true,
		},
	},
	/**
	 * USERS
	 */
	{
		name: "Users",
		path: "/admin/users",
		component: () => import("~/components/admin/users/UsersSection.vue"),
		meta: {
			sectionName: "Управління користувачами",
			isSection: true,
		},
	},
	/**
	 * CLIENTS
	 */
	{
		name: "Clients",
		path: "/admin/clients",
		component: () =>
			import("~/components/admin/clients/ClientsSection.vue"),
		meta: {
			sectionName: "Клієнти",
			isSection: true,
		},
	},
	/**
	 * USER MESSAGES
	 */
	{
		name: "User Messages",
		path: "/admin/user-messages",
		component: () =>
			import("~/components/admin/user-messages/UserMessagesSection.vue"),
		meta: {
			sectionName: "Налаштування повідомлень користувачам",
			isSection: true,
		},
	},
	/**
	 * SCHEDULER
	 */
	{
		name: "Scheduler",
		path: "/admin/scheduler",
		component: QuartzManagement,
		meta: {
			sectionName: "Планувальник",
			isSection: true,
		},
	},
	/**
	 * Profile
	 */
	// {
	// 	name: "Profile",
	// 	path: "/profile",
	// 	component: () => import("~/components/profile/ProfilePage.vue"),
	// },
	{
		name: "Contact profile",
		path: "/profile/:id",
		component: () => import("~/components/profile/ContactProfilePage.vue"),
		props: true,
		meta: {
			admin: true,
		},
	},
	{
		name: "Client profile",
		path: "/client/:id",
		component: () => import("~/components/profile/ClientProfilePage.vue"),
		props: true,
		meta: {
			admin: true,
		},
	},
	/**
	 * PUBLIC ARTICLES
	 */
	{
		path: "/admin/articles",
		name: "Article",
		component: PublicArticlesSection,
	},
	{
		path: "/admin/articles/add/new",
		name: "Add Article",
		component: PublicArticleEditCard,
	},
	{
		path: "/admin/articles/:code",
		name: "Edit Article",
		component: PublicArticleEditCard,
		props: true,
	},
	{
		path: "/article/:code",
		name: "View Article",
		component: PublicArticleView,
		props: true,
		meta: {
			layout: "public",
		},
	},
	/**
	 * SERVICE REQUESTS
	 */
	{
		name: "Edit Service Request",
		path: "/service-request/:id",
		component: () =>
			import("~/components/service-request/ServiceRequestCard.vue"),
		props: true,
	},
	{
		name: "Service Request History",
		path: "/service-requests",
		component: () =>
			import(
				"~/components/service-request/ServiceRequestHistorySection.vue"
			),
		meta: {
			sectionName: "Історія запитів",
			isSection: true,
		},
	},

	/**
	 * LOOKUPS
	 */
	{
		name: "Lookups",
		path: "/admin/lookups",
		component: () =>
			import("~/components/admin/lookups/LookupsSection.vue"),
		meta: {
			sectionName: "Довідники",
			isSection: true,
		},
	},
	{
		name: "AppTypes lookup",
		path: "/admin/lookups/apptypes",
		component: () =>
			import("~/components/admin/lookups/AppTypesLookup.vue"),
	},
	{
		name: "Steps lookup",
		path: "/admin/lookups/steps",
		component: () => import("~/components/admin/lookups/StepsLookup.vue"),
	},
	/**
	 * NOTIFICATIONS
	 */
	{
		name: "Notifications",
		path: "/admin/notifications",
		component: () =>
			import("~/components/admin/notifications/NotificationsSection.vue"),
		meta: {
			sectionName: "Налаштування повідомлень (Notifications)",
			isSection: true,
		},
	},
	{
		name: "NotificationTypeEditCard",
		path: "/admin/notifications/notificationtype/e/:id",
		component: () =>
			import(
				"~/components/admin/notifications/NotificationTypeEditCard.vue"
			),
		props: true,
	},
	/**
	 * EU SIGN FILES
	 */
	{
		name: "EU Sign Files",
		path: "/admin/eu-sign-files",
		component: () =>
			import("~/components/admin/eu-sign-files/EuSignFilesSection.vue"),
		meta: {
			sectionName: "Управління конфігурацією для перевірки КЕП",
			isSection: true,
		},
	},
	/**
	 * ComponentPresetsViewer
	 */
	{
		name: "ComponentPresetsViewer",
		path: "/admin/presets",
		component: ComponentPresetsViewer,
	},
];

const localizeRoute = (pathConfig) => {
	const { locales, defaultLocale } = i18nConfig;
	return locales.map(({ code: locale }) => {
		return locale !== defaultLocale
			? {
					...pathConfig,
					path: `/${locale}${pathConfig.path}`,
					name: `${pathConfig.name}___${locale}`,
					redirect: pathConfig?.redirect
						? `/${locale}${pathConfig.redirect}`
						: null,
			  }
			: {
					...pathConfig,
					// name: `${pathConfig.name}`,
					name: `${pathConfig.name}___${locale}`,
			  };
	});
};

const _localizedRoutes = _customRoutes.flatMap((route) => localizeRoute(route));

export default <RouterConfig>{
	routes: (_routes) => [..._routes, ..._localizedRoutes],
};
